import cn from 'classnames';

import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './Flag.module.scss';

type Props = {
  code: string;
  className?: string;
  rounded?: boolean;
};

const baseClass = 'gdb-flag';

export const Flag = ({ code, className, rounded }: Props) => {
  return (
    <div className={cn(styles[`${baseClass}-wrapper`], rounded && styles[`${baseClass}-wrapper-rounded`], className)}>
      <Icon
        url={`/storage/flags/${code}.svg`}
        className={styles[`${baseClass}-icon`]}
        preserveAspectRatio={rounded ? 'xMidYMid slice' : undefined}
      />
    </div>
  );
};
